<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserCircle } from '@fortawesome/pro-light-svg-icons'

const { t } = useI18n()
const { user } = useAuthStore()
const schoolSelector = useSchoolSelector()

const radioGroupLabel = t('schoolSelector.chooseActiveForSession')
</script>

<template>
  <ModusDialog
    :open="schoolSelector.showDialog"
    hide-close-button
    overlay-image-url="/forside_private.webp"
  >
    <template #title>
      <div>
        <CommonTypography
          variant="h2"
          :component="'span'"
        >
          {{ $t('schoolSelector.welcome') }}
        </CommonTypography>
        <CommonTypography
          variant="body"
          component="span"
          class="username"
        >
          <FontAwesomeIcon
            :icon="faUserCircle"
            aria-hidden="true"
          />
          {{ user?.fullName }}
        </CommonTypography>
      </div>
    </template>
    <template #content>
      <div class="radio-group">
        <CommonTypography
          variant="h4"
          component="h3"
        >
          {{ radioGroupLabel }}
        </CommonTypography>
        <SchoolSelectorRadioGroup :aria-label="radioGroupLabel" />
      </div>
    </template>
    <template #actions>
      <CommonButton
        class="button"
        is-on-dark
        :is-disabled="!schoolSelector.selectedOrganization"
        @click="schoolSelector.updateActive"
      >
        {{ $t('schoolSelector.continue') }}
      </CommonButton>
    </template>
  </ModusDialog>
</template>

<style lang="scss" scoped>
  .dialog-title {
    display: flex;
    flex-direction: column;
    gap: 4px;

    span {
      margin: 0;
    }
  }

  .username {
    font-size: 1.125rem;
    line-height: 32px;
    display: flex;
    align-items: center;
    gap: 12px;

    svg {
      width: 22px;
      height: 22px;
    }
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 16px;
    background-color: var(--color-yellow-10);
    color: var(--color-blue-50);

    h3 {
      margin: 0;
    }
  }

  .button {
    align-self: flex-end;
  }
</style>
